Shopify.colorLabels = function() {
  if ($(".products").length) {
    const $allProducts = $(".products .product");
    let dataQuery = "";
    let productTagsQuery = "";

    $allProducts.each(function() {
      const $this = $(this);
      const productId = $this.data("id");
      const productTag = '\\"Style:' + $this.data("tag") + '\\"';

      if (productId != "" && $this.data("tag") != "") {
        const currentProduct = `
        id${productId}: products(first: 1, query: "tag:${productTag}") {
          pageInfo {
            hasNextPage
          }
        }`;

        productTagsQuery += currentProduct;
      }
    });

    dataQuery = `query {${productTagsQuery}}`;

    if (productTagsQuery) {
      $.ajax({
        url: "https://rachel-pally-staging.myshopify.com/api/graphql",
        method: "POST",
        headers: {
          "X-Shopify-Storefront-Access-Token":
            "cb1e32e786523f4ce6f17f3099944e03",
          "Content-Type": "application/graphql"
        },
        data: dataQuery
      })
        .done(function(data) {
          Shopify.showColorLabels(data);
        })
        .fail(function(error) {
          console.log(error);
        });
    }
  }
};

Shopify.showColorLabels = function(data) {
  const allData = data.data;
  const dataKeys = Object.keys(allData);

  for (let i = 0; i < dataKeys.length; i++) {
    const key = dataKeys[i];
    const tempKey = key.substring(2, key.length);
    const hasMoreColors = allData[key].pageInfo.hasNextPage;

    if (hasMoreColors) {
      $(`[data-id="${tempKey}"]`).addClass("product--more-colors");
    }
  }
};
